import { infiniteCacheConfig } from '@/config/query.config'
import { projected } from '@/services/projected.service'
import { useQuery } from '@tanstack/vue-query'

export function useProjectedSelf() {
  return useQuery({
    queryKey: ['projected-self'],
    queryFn: () => projected.show(),
    ...infiniteCacheConfig,
  })
}
